import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getSupervision } from '../../../../api/Supervision';

export const useSupervisor = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['supervisorData', ...dependencies], () => getSupervision(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};
